// Considered: no existing tooltip atom — creating first-class PrimeReact Tooltip wrapper.
// See spec Reuse Audit (specs/sphere-selector-and-subscriptions.md).
import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import type { TooltipProps } from 'primereact/tooltip';
import './TooltipAtom.scss';

export type { TooltipProps as TooltipAtomProps };

const TooltipAtom: React.FC<TooltipProps> = (props) => <Tooltip {...props} />;

TooltipAtom.displayName = 'TooltipAtom';

export default TooltipAtom;
